import {
  createUser,
  getRoles, getSingleUser, getUsers, updateUser,
} from '@/api/users'

export default {
  EDIT_USER(a, data) {
    return updateUser(data)
  },
  SEARCH_USERS(_, data) {
    return getUsers(data)
  },
  FETCH_USERS({ commit }, data) {
    return new Promise((resolve, reject) => {
      getUsers(data).then(response => {
        commit('SET_USERS_LIST', response.data)
        resolve(response.data)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },
  FETCH_ONE_USER({ commit }, data) {
    return new Promise((resolve, reject) => {
      getSingleUser(data).then(response => {
        commit('SET_ONE_USER', response.data)
        resolve(response.data)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },
  FETCH_ROLES({ commit }, data) {
    return new Promise((resolve, reject) => {
      getRoles(data).then(response => {
        commit('SET_ROLES', response.data)
        resolve(response.data)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },
  CREATE_USER(_, data) {
    return createUser(data)
  },
}
